import styled from "styled-components";
import {
  Checkbox,
  createStyles,
  makeStyles,
  TableSortLabel,
  withStyles,
} from "@material-ui/core";
import { StyledTitle } from "./StyledComponents";
import { colors } from "./colors";

export const TableContainer = styled.div`
  margin: 20px;
  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
  background-color: white;
`;

export const TableTitle = styled(StyledTitle)`
  padding: 20px;
  font-size: 25px;
  color: ${colors.white};
  background-color: ${colors.blue};
  border-bottom: 1px solid ${colors.white};
  margin-bottom: 0px;
  max-width: unset;
`;

export const TableTitleRow = styled(StyledTitle)`
  padding: 20px;
  font-size: 25px;
  color: ${colors.white};
  background-color: ${colors.blue};
  border-bottom: 1px solid ${colors.white};
  margin-bottom: 0px;
  max-width: unset;
  display: flex;
  align-items: center;
  // justify-content: space-end;
`;

export const TableTitleContainer = styled.div`
  background-color: ${colors.blue};
  opacity: 0.6;
  flex-direction: row;
  display: flex;
  border-bottom: 1px solid white;
  flex: 1;
`;

export const SearchInput = styled.input`
  border: 1px solid #d4d4d4;
  font-family: "Lato";
  font-size: 12pt;
  padding: 15px;
`;

export const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

export const StyledTableSortLabel = withStyles(() =>
  createStyles({
    root: {
      color: "white",
      "&:hover": {
        color: "white",
      },
      "&$active": {
        color: "white",
      },
    },
    active: {},
    icon: {
      color: "inherit !important",
    },
  })
)(TableSortLabel);

export const WhiteCheckbox = withStyles(() =>
  createStyles({
    root: {
      color: colors.white,
      "&:hover": {
        background: "#f1f1f106",
      },
      "&$checked": {
        color: colors.white,
        "&:hover": {
          background: "#f1f1f106",
        },
      },
    },
    checked: {},
  })
)(Checkbox);
